import type { PropsWithChildren } from 'react';

import { VModalContextProvider } from './context';

const VModalProvider = ({ children }: PropsWithChildren) => {
  return <VModalContextProvider>{children}</VModalContextProvider>;
};

export default VModalProvider;
